export default __webpack_public_path__ + "static/media/preview-hover-icon.1ee4de30.svg";